<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>À ma fille,</span></p>
<p class="P_Norm-Center"><span>qui m’a appris ce que le coup de foudre</span></p>
<p class="P_Norm-Center"><span>voulait dire.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?66755c70